import React, { useContext, useEffect, useState } from "react";
import { Grid, Button } from "@mui/material";
import "../../../styles/Layout/Admin_Styles/_AdminObjection.scss";
import { Link, useNavigate } from "react-router-dom";
import { apisPath, paths } from "../../../utils/path";
import { authHttp } from "../../services/utility";
import { AuthContext } from "../../../context/AuthContext";
import LoadingImg from "../../../assets/Loading.gif";

const AdminObjection = () => {
  const { setIsLoading, setAlertState } = useContext(AuthContext);
  const navigate = useNavigate();
  const [papers, setPapers] = useState([])

  useEffect(() => {
    getSubjects()
  }, [])

  const getSubjects = () => {
    authHttp
      .get(apisPath?.admin?.getPapers)
      .then((res) => {
        setPapers(res?.data?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      });
  }

  const Loading = () => (
    <div className="loading objection-loader">
      <span>
        <img src={LoadingImg} alt="loading img" className="circle-process" />
      </span>
      <h1>Loading...</h1>
    </div>
  );

  return (
    <div className="admin-objection">
      <div className="admin-objection--header">
        <h2>Objection Reports</h2>
      </div>
      {papers?.length === 0 && <Loading />}
      {papers && papers?.map((paper) => {
        return (
          <Grid container>
            <div className="admin-objection--subHeader">
              <h2>{paper?.subject_desc}({paper?.subject_code})</h2>
            </div>
            <Grid container spacing={2}>
              <Grid item lg={4} md={4} sm={4} xs={12}>
                <div className="admin-objection--card--singleCard">
                  <span>Question Wise Report</span>
                  {/* <Link
                  to={`${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.questionreport}`}
                > */}
                  <div className="admin-objection--card--buttons">
                    <Button variant="outlined" color="success" onClick={() => {
                      navigate(`${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.questionreport}`, { state: {paper:paper,type:"Paid"} })
                    }}>
                      View (Paid)
                    </Button>
                    <Button variant="outlined" color="success" onClick={() => {
                      navigate(`${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.questionreport}`, { state: {paper:paper,type:"Unpaid"} })
                    }}>
                      View (Unpaid)
                    </Button>
                  </div>
                  {/* </Link> */}
                </div>
              </Grid>
              <Grid item lg={4} md={4} sm={4} xs={12}>
                <div className="admin-objection--card--singleCard">
                  <span>Candidate Wise Report</span>
                  {/* <Link
                  to={`${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.candidatereport}`}
                > */}
                  <div className="admin-objection--card--buttons">
                    <Button
                      variant="outlined"
                      color="success"
                      onClick={() =>
                        navigate(`${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.candidatereport}`, { state: {paper:paper,type:"Paid"} })
                      }
                    >
                      View (Paid)
                    </Button>
                    <Button
                      variant="outlined"
                      color="success"
                      onClick={() =>
                        navigate(`${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.candidatereport}`, { state: {paper:paper,type:"Unpaid"} })
                      }
                    >
                      View (Unpaid)
                    </Button>
                  </div>
                  {/* </Link> */}
                </div>
              </Grid>
              <Grid item lg={4} md={4} sm={4} xs={12}>
                <div className="admin-objection--card--singleCard">
                  <span>Question With Image Wise Report</span>
                  {/* <Link
                  to={`${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.questionimgreport}`}
                > */}
                  <div className="admin-objection--card--buttons">
                    <Button
                      variant="outlined"
                      color="success"
                      onClick={() =>
                        navigate(`${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.questionimgreport}`, { state: {paper:paper,type:"Paid"} })
                      }
                    >
                      View (Paid)
                    </Button>
                    <Button
                      variant="outlined"
                      color="success"
                      onClick={() =>
                        navigate(`${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.questionimgreport}`, { state: {paper:paper,type:"Unpaid"} })
                      }
                    >
                      View (Unpaid)
                    </Button>
                  </div>
                  {/* </Link> */}
                </div>
              </Grid>
            </Grid>
          </Grid>
        )
      })}
    </div>
  );
};

export default AdminObjection;
